import { useState } from "react";
import { recordGamePlayed } from "@/utils/playerProfile";

export function useEducationalGames() {
  // Memory
  const [showMemoryGame, setShowMemoryGame] = useState(false);
  const [showMemorySettings, setShowMemorySettings] = useState(false);
  const [memoryCategory, setMemoryCategory] = useState("animals");
  const [memoryPairCount, setMemoryPairCount] = useState(6);
  const [memoryMultiplayer, setMemoryMultiplayer] = useState(false);
  const [memoryP1Name, setMemoryP1Name] = useState("Pemain 1");
  const [memoryP2Name, setMemoryP2Name] = useState("Pemain 2");
  const [memoryPlayerCount, setMemoryPlayerCount] = useState(1);
  const [memoryPlayerNames, setMemoryPlayerNames] = useState(["Pemain 1", "Pemain 2"]);

  // Maze
  const [showMazeGame, setShowMazeGame] = useState(false);
  const [showMazeSettings, setShowMazeSettings] = useState(false);
  const [mazeCharacter, setMazeCharacter] = useState("rabbit");

  // Whack
  const [showWhackGame, setShowWhackGame] = useState(false);
  const [showWhackSettings, setShowWhackSettings] = useState(false);
  const [whackStartLevel, setWhackStartLevel] = useState(null);

  // Snake
  const [showSnakeGame, setShowSnakeGame] = useState(false);
  const [showSnakeSettings, setShowSnakeSettings] = useState(false);
  const [snakeStartLevel, setSnakeStartLevel] = useState(null);

  // Block
  const [showBlockGame, setShowBlockGame] = useState(false);
  const [showBlockSettings, setShowBlockSettings] = useState(false);
  const [blockStartLevel, setBlockStartLevel] = useState(null);

  // Simon
  const [showSimonGame, setShowSimonGame] = useState(false);
  const [showSimonSettings, setShowSimonSettings] = useState(false);
  const [simonStartLevel, setSimonStartLevel] = useState(null);

  // Snake Ladder
  const [showSnakeLadderGame, setShowSnakeLadderGame] = useState(false);
  const [showSnakeLadderSettings, setShowSnakeLadderSettings] = useState(false);
  const [snakeLadderPlayerCount, setSnakeLadderPlayerCount] = useState(2);
  const [snakeLadderPlayerNames, setSnakeLadderPlayerNames] = useState([]);

  // Balon Teman
  const [showBalonTemanGame, setShowBalonTemanGame] = useState(false);

  // Dorong Bola
  const [showDongBolaGame, setShowDongBolaGame] = useState(false);

  // Masak Bareng
  const [showMasakBarengGame, setShowMasakBarengGame] = useState(false);

  // Tebak Gambar
  const [showTebakGambarGame, setShowTebakGambarGame] = useState(false);
  // Menara Balok
  const [showMenaraBalokGame, setShowMenaraBalokGame] = useState(false);
  // Tangkap Bintang
  const [showTangkapBintangGame, setShowTangkapBintangGame] = useState(false);
  // Puzzle Potong
  const [showPuzzlePotongGame, setShowPuzzlePotongGame] = useState(false);
  // Lomba Lari
  const [showLombaLariGame, setShowLombaLariGame] = useState(false);
  // Mewarnai
  const [showMewarnaiGame, setShowMewarnaiGame] = useState(false);
  // Game Hitung
  const [showGameHitungGame, setShowGameHitungGame] = useState(false);
  // Game Musik
  const [showGameMusikGame, setShowGameMusikGame] = useState(false);
  // Game Balap
  const [showGameBalapGame, setShowGameBalapGame] = useState(false);
  // Lempar Bola
  const [showLemparBolaGame, setShowLemparBolaGame] = useState(false);
  // 8 new games (Feb 2026 batch 2)
  const [showTebakSuaraGame, setShowTebakSuaraGame] = useState(false);
  const [showCocokkanWarnaGame, setShowCocokkanWarnaGame] = useState(false);
  const [showBelajarHurufGame, setShowBelajarHurufGame] = useState(false);
  const [showBelajarHariBulanGame, setShowBelajarHariBulanGame] = useState(false);
  const [showTebakBenderaGame, setShowTebakBenderaGame] = useState(false);
  const [showSudokuAnakGame, setShowSudokuAnakGame] = useState(false);
  const [showTebakPolaGame, setShowTebakPolaGame] = useState(false);
  const [showBelajarJamGame, setShowBelajarJamGame] = useState(false);
  // Batch 3
  const [showCeritaInteraktifGame, setShowCeritaInteraktifGame] = useState(false);
  const [showTebakProvinsiGame, setShowTebakProvinsiGame] = useState(false);
  const [showTebakPahlawanGame, setShowTebakPahlawanGame] = useState(false);

  const handleOpenMemoryGame = () => { recordGamePlayed("memory"); setShowMemorySettings(true); };
  const handleStartMemoryGame = (category, pairCount, isMulti, p1Name, p2Name, pCount, pNames) => {
    setMemoryCategory(category);
    setMemoryPairCount(pairCount);
    setMemoryMultiplayer(isMulti || false);
    setMemoryP1Name(p1Name || "Pemain 1");
    setMemoryP2Name(p2Name || "Pemain 2");
    setMemoryPlayerCount(pCount || (isMulti ? 2 : 1));
    setMemoryPlayerNames(pNames || ["Pemain 1", "Pemain 2"]);
    setShowMemorySettings(false);
    setShowMemoryGame(true);
  };
  const handleBackFromMemory = () => { setShowMemoryGame(false); setShowMemorySettings(false); };

  const handleOpenMazeGame = () => { recordGamePlayed("maze"); setShowMazeSettings(true); };
  const handleStartMazeGame = (charId) => { setMazeCharacter(charId); setShowMazeSettings(false); setShowMazeGame(true); };
  const handleBackFromMaze = () => { setShowMazeGame(false); setShowMazeSettings(false); };

  const handleOpenWhackGame = () => { recordGamePlayed("whack"); setShowWhackSettings(true); };
  const handleStartWhackGame = (startLevel) => { setWhackStartLevel(startLevel); setShowWhackSettings(false); setShowWhackGame(true); };
  const handleBackFromWhack = () => { setShowWhackGame(false); setShowWhackSettings(false); };

  const handleOpenSnakeGame = () => { recordGamePlayed("snake"); setShowSnakeSettings(true); };
  const handleStartSnakeGame = (startLevel) => { setSnakeStartLevel(startLevel); setShowSnakeSettings(false); setShowSnakeGame(true); };
  const handleBackFromSnake = () => { setShowSnakeGame(false); setShowSnakeSettings(false); };

  const handleOpenBlockGame = () => { recordGamePlayed("block"); setShowBlockSettings(true); };
  const handleStartBlockGame = (startLevel) => { setBlockStartLevel(startLevel); setShowBlockSettings(false); setShowBlockGame(true); };
  const handleBackFromBlock = () => { setShowBlockGame(false); setShowBlockSettings(false); };

  const handleOpenSimonGame = () => { recordGamePlayed("simon"); setShowSimonSettings(true); };
  const handleStartSimonGame = (startLevel) => { setSimonStartLevel(startLevel); setShowSimonSettings(false); setShowSimonGame(true); };
  const handleBackFromSimon = () => { setShowSimonGame(false); setShowSimonSettings(false); };

  const handleOpenSnakeLadderGame = () => { recordGamePlayed("snakeladder"); setShowSnakeLadderSettings(true); };
  const handleStartSnakeLadderGame = (playerCount, playerNames) => {
    setSnakeLadderPlayerCount(playerCount);
    setSnakeLadderPlayerNames(playerNames);
    setShowSnakeLadderSettings(false);
    setShowSnakeLadderGame(true);
  };
  const handleBackFromSnakeLadder = () => { setShowSnakeLadderGame(false); setShowSnakeLadderSettings(false); };

  const handleOpenBalonTeman = () => { recordGamePlayed("balon"); setShowBalonTemanGame(true); };
  const handleBackFromBalonTeman = () => setShowBalonTemanGame(false);

  const handleOpenDongBola = () => { recordGamePlayed("dongbola"); setShowDongBolaGame(true); };
  const handleBackFromDongBola = () => setShowDongBolaGame(false);

  const handleOpenMasakBareng = () => { recordGamePlayed("masak"); setShowMasakBarengGame(true); };
  const handleBackFromMasakBareng = () => setShowMasakBarengGame(false);

  const handleOpenTebakGambar = () => { recordGamePlayed("tebak"); setShowTebakGambarGame(true); };
  const handleBackFromTebakGambar = () => setShowTebakGambarGame(false);
  const handleOpenMenaraBalok = () => { recordGamePlayed("menara"); setShowMenaraBalokGame(true); };
  const handleBackFromMenaraBalok = () => setShowMenaraBalokGame(false);
  const handleOpenTangkapBintang = () => { recordGamePlayed("tangkap"); setShowTangkapBintangGame(true); };
  const handleBackFromTangkapBintang = () => setShowTangkapBintangGame(false);
  const handleOpenPuzzlePotong = () => { recordGamePlayed("puzzle"); setShowPuzzlePotongGame(true); };
  const handleBackFromPuzzlePotong = () => setShowPuzzlePotongGame(false);
  const handleOpenLombaLari = () => { recordGamePlayed("lomba"); setShowLombaLariGame(true); };
  const handleBackFromLombaLari = () => setShowLombaLariGame(false);
  const handleOpenMewarnai = () => { recordGamePlayed("mewarnai"); setShowMewarnaiGame(true); };
  const handleBackFromMewarnai = () => setShowMewarnaiGame(false);
  const handleOpenGameHitung = () => { recordGamePlayed("hitung"); setShowGameHitungGame(true); };
  const handleBackFromGameHitung = () => setShowGameHitungGame(false);
  const handleOpenGameMusik = () => { recordGamePlayed("musik"); setShowGameMusikGame(true); };
  const handleBackFromGameMusik = () => setShowGameMusikGame(false);
  const handleOpenGameBalap = () => { recordGamePlayed("balap"); setShowGameBalapGame(true); };
  const handleBackFromGameBalap = () => setShowGameBalapGame(false);
  const handleOpenLemparBola = () => { recordGamePlayed("lempar"); setShowLemparBolaGame(true); };
  const handleBackFromLemparBola = () => setShowLemparBolaGame(false);

  const handleOpenTebakSuara = () => { recordGamePlayed("suara"); setShowTebakSuaraGame(true); };
  const handleBackFromTebakSuara = () => setShowTebakSuaraGame(false);
  const handleOpenCocokkanWarna = () => { recordGamePlayed("warna"); setShowCocokkanWarnaGame(true); };
  const handleBackFromCocokkanWarna = () => setShowCocokkanWarnaGame(false);
  const handleOpenBelajarHuruf = () => { recordGamePlayed("huruf"); setShowBelajarHurufGame(true); };
  const handleBackFromBelajarHuruf = () => setShowBelajarHurufGame(false);
  const handleOpenBelajarHariBulan = () => { recordGamePlayed("haribulan"); setShowBelajarHariBulanGame(true); };
  const handleBackFromBelajarHariBulan = () => setShowBelajarHariBulanGame(false);
  const handleOpenTebakBendera = () => { recordGamePlayed("bendera"); setShowTebakBenderaGame(true); };
  const handleBackFromTebakBendera = () => setShowTebakBenderaGame(false);
  const handleOpenSudokuAnak = () => { recordGamePlayed("sudoku"); setShowSudokuAnakGame(true); };
  const handleBackFromSudokuAnak = () => setShowSudokuAnakGame(false);
  const handleOpenTebakPola = () => { recordGamePlayed("pola"); setShowTebakPolaGame(true); };
  const handleBackFromTebakPola = () => setShowTebakPolaGame(false);
  const handleOpenBelajarJam = () => { recordGamePlayed("jam"); setShowBelajarJamGame(true); };
  const handleBackFromBelajarJam = () => setShowBelajarJamGame(false);
  const handleOpenCeritaInteraktif = () => { recordGamePlayed("cerita"); setShowCeritaInteraktifGame(true); };
  const handleBackFromCeritaInteraktif = () => setShowCeritaInteraktifGame(false);
  const handleOpenTebakProvinsi = () => { recordGamePlayed("provinsi"); setShowTebakProvinsiGame(true); };
  const handleBackFromTebakProvinsi = () => setShowTebakProvinsiGame(false);
  const handleOpenTebakPahlawan = () => { recordGamePlayed("pahlawan"); setShowTebakPahlawanGame(true); };
  const handleBackFromTebakPahlawan = () => setShowTebakPahlawanGame(false);

  return {
    // Memory
    showMemoryGame, showMemorySettings, memoryCategory, memoryPairCount,
    memoryMultiplayer, memoryP1Name, memoryP2Name, memoryPlayerCount, memoryPlayerNames,
    handleOpenMemoryGame, handleStartMemoryGame, handleBackFromMemory,
    // Maze
    showMazeGame, showMazeSettings, mazeCharacter,
    handleOpenMazeGame, handleStartMazeGame, handleBackFromMaze,
    // Whack
    showWhackGame, showWhackSettings, whackStartLevel,
    handleOpenWhackGame, handleStartWhackGame, handleBackFromWhack,
    // Snake
    showSnakeGame, showSnakeSettings, snakeStartLevel,
    handleOpenSnakeGame, handleStartSnakeGame, handleBackFromSnake,
    // Block
    showBlockGame, showBlockSettings, blockStartLevel,
    handleOpenBlockGame, handleStartBlockGame, handleBackFromBlock,
    // Simon
    showSimonGame, showSimonSettings, simonStartLevel,
    handleOpenSimonGame, handleStartSimonGame, handleBackFromSimon,
    // Snake Ladder
    showSnakeLadderGame, showSnakeLadderSettings, snakeLadderPlayerCount, snakeLadderPlayerNames,
    handleOpenSnakeLadderGame, handleStartSnakeLadderGame, handleBackFromSnakeLadder,
    // Balon Teman
    showBalonTemanGame, handleOpenBalonTeman, handleBackFromBalonTeman,
    // Dorong Bola
    showDongBolaGame, handleOpenDongBola, handleBackFromDongBola,
    // Masak Bareng
    showMasakBarengGame, handleOpenMasakBareng, handleBackFromMasakBareng,
    // New games
    showTebakGambarGame, handleOpenTebakGambar, handleBackFromTebakGambar,
    showMenaraBalokGame, handleOpenMenaraBalok, handleBackFromMenaraBalok,
    showTangkapBintangGame, handleOpenTangkapBintang, handleBackFromTangkapBintang,
    showPuzzlePotongGame, handleOpenPuzzlePotong, handleBackFromPuzzlePotong,
    showLombaLariGame, handleOpenLombaLari, handleBackFromLombaLari,
    showMewarnaiGame, handleOpenMewarnai, handleBackFromMewarnai,
    showGameHitungGame, handleOpenGameHitung, handleBackFromGameHitung,
    showGameMusikGame, handleOpenGameMusik, handleBackFromGameMusik,
    showGameBalapGame, handleOpenGameBalap, handleBackFromGameBalap,
    showLemparBolaGame, handleOpenLemparBola, handleBackFromLemparBola,
    showTebakSuaraGame, handleOpenTebakSuara, handleBackFromTebakSuara,
    showCocokkanWarnaGame, handleOpenCocokkanWarna, handleBackFromCocokkanWarna,
    showBelajarHurufGame, handleOpenBelajarHuruf, handleBackFromBelajarHuruf,
    showBelajarHariBulanGame, handleOpenBelajarHariBulan, handleBackFromBelajarHariBulan,
    showTebakBenderaGame, handleOpenTebakBendera, handleBackFromTebakBendera,
    showSudokuAnakGame, handleOpenSudokuAnak, handleBackFromSudokuAnak,
    showTebakPolaGame, handleOpenTebakPola, handleBackFromTebakPola,
    showBelajarJamGame, handleOpenBelajarJam, handleBackFromBelajarJam,
    showCeritaInteraktifGame, handleOpenCeritaInteraktif, handleBackFromCeritaInteraktif,
    showTebakProvinsiGame, handleOpenTebakProvinsi, handleBackFromTebakProvinsi,
    showTebakPahlawanGame, handleOpenTebakPahlawan, handleBackFromTebakPahlawan,
  };
}
